export default function Issue() {
  return (
    <p className="sm:text-sm text-xs text-center text-gray-500 m-2">
      Feel free to contribute, report a bug, or request a feature at <a href="https://github.com/aristorinjuang/image-service/issues" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">https://github.com/aristorinjuang/image-service/issues</a>.
    </p>
  )
}